import { Component, OnInit } from '@angular/core';

import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import * as moment from 'moment';

import { MatSnackBar } from '@angular/material';
import { NestService } from '../../services/nest.service';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-nestotherservices',
  templateUrl: './nestotherservices.component.html',
  styleUrls: ['./nestotherservices.component.css']
})
export class NestotherservicesComponent implements OnInit {
  completeflag: number;
  paidserviceid: any;
  action: any;
  msg: any;
  selectedtime: any;
  service: any;
  loading: boolean;
  today: any;
  servicedescription: any;
  servicefees: any;
  formcheck: number;

  otherpaidservice: any;
  registrationform: any;
  timeslots = ['8 am to 9 am', '9 am to 10 am', '10 am to 11 am', '11 am to 12 pm', '12 pm to 1 pm', '1 pm to 2 pm', '2 pm to 3 pm',
  '3 pm to 4 pm', '5 pm to 6 pm', '6 pm to 7 pm', '7 pm to 8 pm'];
  constructor(private nestService: NestService,  public form: FormBuilder, private commonService: CommonService,
    private snackbar: MatSnackBar) { 
    this.formcheck = 0;
    this.completeflag = 0;
    this.registrationform = this.form.group({
      'name': new FormControl('', Validators.required),
      'petname': new FormControl('', Validators.required),
      'email': new FormControl('', [Validators.pattern(".+\@.+\.+\..+")]),
      'mobile': new FormControl('', [Validators.required, Validators.minLength(10)]),
      'noofpets': new FormControl('' , [Validators.required]),
      'date': new FormControl('', [Validators.required]),
      'time': new FormControl(''),


      });

  }

  ngOnInit() {
    this.getDate();
    this.getOthernestServices();
  }

  getOthernestServices(){
    this.nestService.getOthernestServices()
    .subscribe((x) => {
      this.otherpaidservice = x;
    });
  }

  radioChange(o) {
    this.registrationform.time = undefined;
    for (let i = 0; i < this.otherpaidservice.length; i++) {
        if (this.otherpaidservice[i].name === o) {
          this.service = this.otherpaidservice[i].name;
          this.formcheck = 1;
          this.servicefees = this.otherpaidservice[i].fees;
          this.servicedescription = this.otherpaidservice[i].Description;
          this.paidserviceid = this.otherpaidservice[i].id;

        }
    }
  }

  getDate(){
    this.loading = true;
    this.commonService.getTime()
    .subscribe(
      (x)=>{
       const ctime = x.date;
       this.today = moment(ctime.date).format('YYYY-MM-DD');
       this.loading = false;

      });
  }

  changeSelectedTime(d) {
    this.selectedtime = d;
    console.log('selectedtime', this.selectedtime);
  }

  openSnackBar() {
    this.snackbar.open(this.msg , this.action, {
      duration: 3000,
    });
  }
  
  submit(){
    var paymentstats = 'Pending';
    if(this.registrationform.email === undefined || this.registrationform.email === '') {
      var email = 'Not specified';
    } else {
      email = this.registrationform.email;
    }

    if(this.registrationform.time == undefined && this.paidserviceid !== 7) {
      this.registrationform.time = 'Any Time';
    } 
    if( this.registrationform.time === undefined && this.paidserviceid == 7) {
      this.msg = 'Select Time Slots';
     this.openSnackBar();
    } else {
      this.loading = true;
      console.log('submission', this.registrationform.name, this.registrationform.petname, this.registrationform.mobile,
      email, this.service, this.servicefees, this.registrationform.date, this.registrationform.time, paymentstats);
      this.nestService.postNestServiceBooking(this.registrationform.name, this.registrationform.petname, this.registrationform.mobile,
        email, this.service, this.servicefees, this.registrationform.date, this.registrationform.time, paymentstats)
      .subscribe((x) => {
        console.log(x);
        this.completeflag = 1;
        this.loading = false;
        this.msg = 'Other Services Booking Confirmed';
        this.openSnackBar();
      })
    }
  }
}
